import { useSyncExternalStore } from 'react';

/**
 * Opcja „Dołącz informacje o źródłach ciepła" dla WSZYSTKICH pobrań podsumowania kontroli
 * (Bronek 14.10: „w podsumowaniu kontroli dla Zarządcy żeby nie było informacji o źródłach ciepła.
 * Ewentualnie żeby to była opcja […] głównie dla mnie").
 *
 * JEDNA wartość na cały panel: zaznaczenie w szczegółach budynku obowiązuje też w „Pobierz ▾"
 * listy budynków i w paczce wg filtrów (i odwrotnie) — pole w każdym z tych miejsc pokazuje ten
 * sam stan. Domyślnie wyłączona i NIEzapamiętywana: odświeżenie panelu wraca do kopii dla zarządcy
 * (bez źródeł), żeby zapomniane zaznaczenie nie wysłało zarządcom źródeł ciepła.
 */
let includeHeatSources = false;
const listeners = new Set<() => void>();

export function setSummaryHeatSources(value: boolean): void {
  if (value === includeHeatSources) return;
  includeHeatSources = value;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

const getSnapshot = () => includeHeatSources;

export function useSummaryHeatSources(): [boolean, (value: boolean) => void] {
  return [useSyncExternalStore(subscribe, getSnapshot), setSummaryHeatSources];
}
